/**
 * Visitor identity is PostHog's ID in full mode; traffic can use a per-document
 * UUID when PostHog is absent. Runtime IDs are never sent as person identity.
 */
import { getPostHog } from '../../analytics';
import { getConsentMode, subscribeConsentMode } from '../../services/consentMode';

let rememberedClientId: string | null = null;
let runtimeClientId: string | null = null;

export function getRuntimeClientId(): string {
    runtimeClientId ??= crypto.randomUUID();
    return runtimeClientId;
}

type PostHogLike = { get_distinct_id?: () => unknown };

export function getStableClientId(posthog?: unknown): string {
    if (getConsentMode() !== 'full') return getRuntimeClientId();
    if (rememberedClientId) return rememberedClientId;
    try {
        const instance = (posthog || getPostHog()) as PostHogLike | null;
        const id = instance?.get_distinct_id?.();
        if (typeof id === 'string' && id && id !== '$posthog_cookieless') {
            rememberedClientId = id;
            return id;
        }
    } catch {
        // Analytics availability must not control whether the visitor can chat.
    }
    return getRuntimeClientId();
}

export function tryGetStableClientId(posthog?: unknown): string | null {
    return getStableClientId(posthog);
}

subscribeConsentMode((mode) => {
    if (mode !== 'full') rememberedClientId = null;
});

export function clearRememberedClientIdForTests(): void {
    rememberedClientId = null;
    runtimeClientId = null;
}
